// Single seam between the app and the error-tracking vendor (mirrors lib/exception_notifier.rb).
export function reportError (error, context, groupingHash) {
  console.error(error)
  if (typeof window.Bugsnag === 'undefined') return
  window.Bugsnag.notify(error, (event) => {
    if (groupingHash !== undefined) event.groupingHash = groupingHash
    if (context === undefined) return
    event.addMetadata('context', typeof context === 'object' && context !== null ? context : { value: context })
  })
}

// For detected conditions with no real exception to wrap.
export function reportMessage (name, message, context) {
  const error = new Error(`${name}: ${message}`)
  Error.captureStackTrace?.(error, reportMessage)
  reportError(error, context, name)
}
